var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"upload-page"},[_c('div',{staticClass:"upload-content"},[_c('FileUpload'),(_vm.fileUploadStatuses.length > 0)?_c('ProcessingPageContent'):_vm._e(),_c('Captcha')],1),_c('DemoOffering',{staticClass:"demo-offering"}),_c('Footer',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }